import { Text } from "../../../../components/common/typography";
import { SectionCard } from "./section-card";
import { AddressBookSection } from "../../../addresses/components/address-book-section";

/**
 * Account → Shipping addresses tab.
 *
 * These are the buyer's saved delivery locations, backed by Odoo partner
 * child records with `type = delivery`.
 */
export function ShippingAddressesSection() {
  return (
    <SectionCard title="Shipping addresses">
      <Text variant="bodySm" tone="muted">
        Saved ship-to contacts used at checkout. Add as many delivery locations
        as you need for offices, warehouses, or job sites.
      </Text>
      <AddressBookSection type="delivery" mode="manage" heading="" />
    </SectionCard>
  );
}
